import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4core from "@amcharts/amcharts4/core";

class CoreAmChart {
  constructor() {}

  createXYDateChart($el) {
    const chart = am4core.create($el, am4charts.XYChart);

    // chart.dateFormatter.dateFormat = "yyyy-MM-dd HH:mm";
    chart.paddingRight = 20;

    chart.customItem = {};
    const dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    chart.customItem.dateAxis = dateAxis;
    // default
    // day: "MMM dd"
    // hour: "HH:mm"
    // millisecond: "mm:ss SSS"
    // minute: "HH:mm"
    // month: "MMM"
    // second: "HH:mm:ss"
    // week: "MMM dd"
    // year: "yyyy"
    dateAxis.dateFormats.setKey("day", "MM월 dd일");
    dateAxis.dateFormats.setKey("month", "MM월");
    dateAxis.dateFormats.setKey("week", "MM월 dd일");
    dateAxis.dateFormats.setKey("year", "yyyy년");

    // default
    // day: "MMM dd"
    // hour: "MMM dd"
    // millisecond: "mm:ss SSS"
    // minute: "HH:mm"
    // month: "MMM yyyy"
    // second: "HH:mm:ss"
    // week: "MMM dd"
    dateAxis.periodChangeDateFormats.setKey("day", "MM월 dd일");
    dateAxis.periodChangeDateFormats.setKey("hour", "MM월 dd일");
    dateAxis.periodChangeDateFormats.setKey("month", "yyyy년 MM월");
    dateAxis.periodChangeDateFormats.setKey("week", "MM월 dd일");

    dateAxis.tooltipDateFormat = "MM월 dd일 HH시 mm분";

    dateAxis.tooltip.label.padding(5, 10, 5, 10);
    dateAxis.tooltip.label.fill = am4core.color("#fff");

    dateAxis.renderer.minGridDistance = 80;
    dateAxis.renderer.grid.template.location = 0;
    dateAxis.renderer.axisFills.template.disabled = true;
    dateAxis.renderer.ticks.template.disabled = true;

    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    // valueAxis.min = 0;
    // valueAxis.max = 100;
    valueAxis.tooltip.disabled = true;
    valueAxis.renderer.minWidth = 35;
    valueAxis.renderer.axisFills.template.disabled = true;
    valueAxis.renderer.ticks.template.disabled = true;
    chart.customItem.valueAxis = valueAxis;

    return chart;
  }

  createXYCategoryChart($el, categoryName) {
    const chart = am4core.create($el, am4charts.XYChart);

    // chart.dateFormatter.dateFormat = "yyyy-MM-dd HH:mm";
    chart.paddingRight = 20;

    chart.customItem = {};
    const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    chart.customItem.categoryAxis = categoryAxis;

    categoryAxis.dataFields.category = "title";
    categoryAxis.tooltip.label.padding(5, 10, 5, 10);
    categoryAxis.tooltip.label.fill = am4core.color("#fff");

    categoryAxis.renderer.minGridDistance = 80;
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.axisFills.template.disabled = true;
    categoryAxis.renderer.ticks.template.disabled = true;

    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    // valueAxis.min = 0;
    // valueAxis.max = 100;
    valueAxis.tooltip.disabled = true;
    valueAxis.renderer.minWidth = 35;
    valueAxis.renderer.axisFills.template.disabled = true;
    valueAxis.renderer.ticks.template.disabled = true;
    chart.customItem.valueAxis = valueAxis;

    return chart;
  }

  createLineSeries(chart, field, dateField, name, colorHex, unit) {
    const series = chart.series.push(new am4charts.LineSeries());
    series.dataFields.valueY = field;
    series.dataFields.dateX = dateField;
    series.name = name;
    series.strokeWidth = 2;
    series.minBulletDistance = 60;
    series.tooltipText =
      "{name} [bold font-size: 20px]{valueY} [font-size: 12px]" + unit;
    series.legendSettings.valueText = "{valueY}";
    if (colorHex != null) {
      series.stroke = am4core.color(colorHex);
      series.fill = am4core.color(colorHex);
    }

    series.sequencedInterpolation = true;
    const bullet = series.bullets.push(new am4charts.CircleBullet());
    bullet.circle.fill = am4core.color("#fff");
    // bullet.circle.stroke = am4core.color("#fff");
    bullet.circle.strokeWidth = 3;
    return series;
  }

  createCategoryLineSeries(chart, field, dateField, name, colorHex, unit) {
    const series = chart.series.push(new am4charts.LineSeries());
    series.dataFields.valueY = field;
    series.dataFields.categoryX = dateField;
    series.name = name;
    series.strokeWidth = 2;
    series.minBulletDistance = 60;
    series.tooltipText =
      "{name} [bold font-size: 20px]{valueY} [font-size: 12px]" + unit;
    series.legendSettings.valueText = "{valueY}";
    if (colorHex != null) {
      series.stroke = am4core.color(colorHex);
      series.fill = am4core.color(colorHex);
    }

    series.sequencedInterpolation = true;
    const bullet = series.bullets.push(new am4charts.CircleBullet());
    bullet.circle.fill = am4core.color("#fff");
    // bullet.circle.stroke = am4core.color("#fff");
    bullet.circle.strokeWidth = 3;
    return series;
  }

  createRangeLineSeries(chart, openField, field, dateField, name, colorHex) {
    const series = chart.series.push(new am4charts.LineSeries());
    series.dataFields.dateX = dateField;
    series.dataFields.openValueY = openField;
    series.dataFields.valueY = field;
    series.sequencedInterpolation = true;
    series.name = name;
    series.strokeWidth = 2;
    // series.minBulletDistance = 20;
    series.legendSettings.valueText = "{valueY}";
    if (colorHex != null) {
      series.stroke = am4core.color(colorHex);
      series.fill = am4core.color(colorHex);
    }
    series.fillOpacity = 0.8;

    // const bullet = series.bullets.push(new am4charts.CircleBullet());
    // bullet.circle.fill = am4core.color("#fff");
    // // bullet.circle.stroke = am4core.color("#fff");
    // bullet.circle.strokeWidth = 3;
    return series;
  }

  createColumnSeries(chart, field, dateField, name, colorHex, unit) {
    const series = chart.series.push(new am4charts.ColumnSeries());
    series.dataFields.valueY = field;
    series.dataFields.dateX = dateField;
    series.name = name;
    series.strokeWidth = 15;
    series.minBulletDistance = 60;
    // series.columns.template.fillOpacity = 0.7;
    // series.columns.template.propertyFields.strokeDasharray = "dashLength";
    // series.columns.template.propertyFields.fillOpacity = "alpha";
    series.tooltipText =
      "{name} [bold font-size: 20px]{valueY} [font-size: 12px]" + unit;
    series.legendSettings.valueText = "{valueY}";
    if (colorHex != null) {
      series.stroke = am4core.color(colorHex);
      series.fill = am4core.color(colorHex);
    }

    series.sequencedInterpolation = true;
    const bullet = series.bullets.push(new am4charts.CircleBullet());
    bullet.circle.fill = am4core.color("#fff");
    // bullet.circle.stroke = am4core.color("#fff");
    bullet.circle.strokeWidth = 3;
    return series;
  }

  addLineChartRange(valueAxis, series, value, endValue, color) {
    const range = valueAxis.createSeriesRange(series);
    range.value = value;
    range.endValue = endValue;
    range.contents.stroke = am4core.color(color);
    range.contents.fill = am4core.color(color);
  }

  addColumnChartAdapter(series, callback) {
    const columnTemplate = series.columns.template;
    columnTemplate.adapter.add("fill", function (fill, target) {
      const values = target.dataItem.values;
      const value = values.valueY.value;
      return callback(value);
    });
    columnTemplate.adapter.add("stroke", function (fill, target) {
      const values = target.dataItem.values;
      const value = values.valueY.value;
      return callback(value);
    });
  }
}

export default new CoreAmChart();
